import { render } from "./rate.view.vue?vue&type=template&id=59c0068c&scoped=true&ts=true"
import script from "./rate.view.vue?vue&type=script&lang=ts"
export * from "./rate.view.vue?vue&type=script&lang=ts"

import "./rate.view.vue?vue&type=style&index=0&id=59c0068c&lang=scss&scoped=true"

import exportComponent from "/agent/_work/1/s/Customer/onlinekiosk_vue_js/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59c0068c"]])

export default __exports__